import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchAnotherArray'
})
export class MatchAnotherArrayPipe implements PipeTransform {
  transform(value: any[], targetArr: any[]): any {
    if (!value || !Array.isArray(value)) { return false; }
    return chechArrayisMatchWithAnother(value, targetArr);
  }
}

/** 檢查兩陣列內容物相同，不論排序 */
export const chechArrayisMatchWithAnother = (array: any[], targetArr: any[]) => {
  let missAny = false;
  for (let i = 0; i < targetArr.length && !missAny; i++) {
    const f = array.find(s => s === targetArr[i]);
    if (!f) { missAny = true; }
  }
  return !missAny && array.length === targetArr.length;
};
